import React from 'react'
import { variant } from 'styled-system'
import styled, { css } from 'styled-components'

import Box from '../Box'

import { StyledDrawerProps } from './Drawer.types'

const placement = variant({
  prop: 'placement',
  variants: {
    top: {
      top: '0px',
      left: '0px',
      right: '0px',
      borderRadius: '0px 0px 16px 16px',
      transform: 'translateY(-100%)',
    },
    bottom: {
      bottom: '0px',
      left: '0px',
      right: '0px',
      borderRadius: '16px 16px 0px 0px',
      transform: 'translateY(100%)',
    },
    left: {
      bottom: '0px',
      left: '0px',
      top: '0px',
      transform: 'translateX(-105%)',
    },
    right: {
      bottom: '0px',
      right: '0px',
      top: '0px',
      transform: 'translateX(100%)',
    },
  },
})

const getStyleFullSize = css`
  height: 100dvh;
  width: 100vw;
  border-radius: 0px;
`

export const StyledDrawer: React.FC<StyledDrawerProps> = styled(Box)<StyledDrawerProps>`
  transition: transform 0.3s ease;
  ${placement}
  ${(props) =>
    props.isOpen &&
    css`
      transform: translate(0);
    `}
  ${(props) => props.isFullPage && getStyleFullSize}
`
